<template>
  <div>
    <crumb-tit>
      <span slot="breadTit">{{ crumbLabel }}</span>
      <span slot="secondTit">{{ crumbLabel }}</span>
    </crumb-tit>
    <div class="main">
      <router-view />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import CrumbTit from '@/components/pc/config/CrumbTit'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    CrumbTit
  },
  data () {
    return {
      crumbTitle: {
        ServiceSms: this.$t('message["252"]'),
        ServiceEmail: this.$t('message["1502"]')
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      const { name } = to
      vm.setCrumbLabel(vm.crumbTitle[name])
      if (name === 'ServiceSms') {
        vm.$router.push({ name: 'ServiceSms' })
      } else if (name === 'ServiceEmail') {
        vm.$router.push({ name: 'ServiceEmail' })
      } else {
        vm.getService()
      }
    })
  },
  computed: {
    ...mapState('config/service', ['crumbLabel']),
    ...mapState(['baseinfo'])
  },
  watch: {
    $route (to, from) {
      const { name } = to
      if (name === 'configService') {
        this.$router.push({ name: 'configIndex' })
      }
    },
    baseinfo (newVal) {
      document.title = this.$t('message["312"]') + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  methods: {
    ...mapActions('config/service', ['getServiceInfo', 'setCrumbLabel', 'setServiceInfoData']),
    async getService () {
      const chain = await this.getServiceInfo()
      chain.onSuccess(res => {
        this.setServiceInfoData(res)
        const { vip } = res
        if (vip) {
          this.setCrumbLabel(this.$t('message["579"]'))
          // if (res.remark.usedvip === 1) {
          //   this.setCrumbLabel(this.$t('message["312"]'))
          // }
          this.setCrumbLabel(this.$t('message["312"]'))
          this.$router.push({ name: 'ServiceSuper' })
        } else {
          this.setCrumbLabel(this.$t('message["312"]'))
          this.$router.push({ name: 'ServiceIndex' })
        }
      })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  margin-bottom: 40px;
}
</style>
